import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { TrialRegionActions, TrialRegionActionsCreators } from 'actions/trialRegions/types/actions';
import { GeoJson } from 'types/GeoJson';
import { getMessage } from '@tcc/i18n';
import styles from './TrialRegionCard.css';
import trialRegionActionsCreators from '../../../actions/trialRegions/actions';
import { TrialRegion, Role } from '../../../types/TrialRegion';
import { getCurrentSeasonYear } from '../../../selectors/seasonSelectors';
import { getGeoJson } from '../../../utils/geo';
import { getInversedFieldBoundary } from '../../../selectors/fieldSelectors';

import FieldThumbnail from '../../../components/FieldThumbnail/FieldThumbnail';

interface TrialRegionCardProps {
  fetchTrialRegions: TrialRegionActionsCreators['fetchTrialRegions'];
  experimentalUnits: TrialRegion['experimentalUnits'];
  currentSeasonYear: string;
  fieldBoundary: GeoJson;
}

interface TrialRegionCardContentProps {
  name: string;
  seasonYear: string;
  role: Role;
  fieldBoundary: GeoJson;
  geometry: GeoJson;
}

const TrialRegionCardContent: React.FC<TrialRegionCardContentProps> = ({
  name,
  seasonYear,
  role,
  geometry,
  fieldBoundary
}) => (
  <div className={styles.row} data-test-id="no-trial-regions">
    <div className={styles.title}>
      <div className={styles.trialRegionZone}>
        <FieldThumbnail
          fillColor="#FFF"
          geoJson={getGeoJson([fieldBoundary, geometry])}
          regionColor="#8fb4fc"
          regionFillOpacity={0.2} />
      </div>
      <div className={styles.containerExpUnitData}>
        <div className={styles.expUnitName}>
          {seasonYear} {name}
        </div>
        <div className={styles.subTitleData}>
          {role === Role.CHAMPION
            ? getMessage('trial.region.untreated')
            : getMessage('trial.region.treated')}{' '}
          {getMessage('area')}
        </div>
      </div>
    </div>
  </div>
)

const TrialRegionCard: React.FC<TrialRegionCardProps> = ({
  fetchTrialRegions,
  experimentalUnits,
  currentSeasonYear,
  fieldBoundary,
}) => {

  useEffect(() => {
    fetchTrialRegions({ fieldId: 'mock', programId: 'mock' });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return (
    <div>
      <div className={styles.card}>
        <div className={styles.cardTittle}>
          <div className={styles.titleEmptyData}>
            <h2>Trial Regions</h2>
            {!experimentalUnits || experimentalUnits.length === 0 ? (
              <div className={styles.empty}>
                {' '}
                {getMessage('card.noTrialRegions')}{' '}
              </div>
            ) : (
              experimentalUnits.map(({ challengers, champion }) => (
                <>
                  <TrialRegionCardContent
                    fieldBoundary={fieldBoundary}
                    name={champion.name}
                    seasonYear={currentSeasonYear}
                    role={Role.CHAMPION}
                    geometry={champion.geometry}
                  />
                  {challengers.map((challenger) => (
                    <TrialRegionCardContent
                      fieldBoundary={fieldBoundary}
                      name={challenger.name}
                      seasonYear={currentSeasonYear}
                      role={Role.CHALLENGER}
                      geometry={challenger.geometry}
                    />
                  ))}
                </>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    experimentalUnits: state.trialRegion.experimentalUnits,
    currentSeasonYear: getCurrentSeasonYear(state, { index: 0 }),
    fieldBoundary: getInversedFieldBoundary(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<TrialRegionActions>) {
  const { fetchTrialRegions } = trialRegionActionsCreators;

  return {
    ...bindActionCreators(
      {
        fetchTrialRegions,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrialRegionCard);

